import React from 'react';
import { useHistory } from "react-router-dom";
import Button from '../../Button';
import MagnetboardElementary from '../MagnetboardElementary';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

import '../../../css/elementary/auto_scheduling_setup.css';

export default function PlacePullouts({ isLoading, schoolSubscribed, subscreenLocked, subscreenRestricted, schoolInfoLoading, schoolInfo, scheduleInfoLoading, scheduleInfo, periodsLoading, periods, coursesLoading, courses, setCourses, teachersLoading, teachers, setTeachers, studentsLoading, students, setStudents, classroomsLoading, classrooms, setClassrooms, blocksLoading, blocks, setBlocks, setLoadScreen }) {
	const history = useHistory();
	const pullouts_teachers_ids = teachers.reduce((results, teacher) => {
		const teacher_id = teacher.teacher_id;
		const teacher_can_teach = teacher.teacher_can_teach;
		
		const teacher_teaches_pullouts = teacher_can_teach.reduce((result, tct_course_info) => {
			const tct_course_id = tct_course_info.course_id;
			const course_info = courses.find(course => course.course_id === tct_course_id);
			if(course_info && course_info.is_pullout === '1') result = true;
			return result;
		}, false)

		if(teacher_teaches_pullouts)  results.push(teacher_id);
		return results;
	},[]);

	const handleGoToMagnetboard = () => {
		setLoadScreen('magnetboard');
		history.push('/app/elementary/magnetboard');
	};

	return (
		<>
		{(subscreenRestricted) ?
		(
			<div className='general-screen-message'>
				<FontAwesomeIcon className='dark-blue-text' style={{fontSize:'60px'}} icon={faLock}/>
				<h1>No Access</h1>
				<div>You do not have access to this screen</div>	
			</div>
		):(subscreenLocked) ?
		(
			<div className='general-screen-message'>
				<FontAwesomeIcon className='dark-blue-text' style={{fontSize:'60px'}} icon={faLock}/>
				<h1>Temporarily Locked</h1>
				<div>This screen is locked until all other prior steps are completed</div>	
			</div>
		):(isLoading) ?
		(
			<div className='center-text'>
				<img src={require('../../../images/balls.gif')} alt='Loading...' style={{height:'25px'}}/>
			</div>
		):
		(
			<>
				<MagnetboardElementary schoolSubscribed={schoolSubscribed} schoolInfo={schoolInfo} schoolInfoLoading={schoolInfoLoading} scheduleInfo={scheduleInfo} scheduleInfoLoading={scheduleInfoLoading} periodsLoading={periodsLoading} periods={periods} teachersLoading={teachersLoading} teachers={teachers} setTeachers={setTeachers} coursesLoading={coursesLoading} courses={courses} setCourses={setCourses} classroomsLoading={classroomsLoading} classrooms={classrooms} setClassrooms={setClassrooms} studentsLoading={studentsLoading} students={students} setStudents={setStudents} blocksLoading={blocksLoading} blocks={blocks} setBlocks={setBlocks} magnetboardOptions={{screen_title: "Place Pullouts", show_conflicts:false, allowed_teacher_ids: pullouts_teachers_ids}}/>
				<div className='fixed-bottom-save-container'>
					<Button classes={['btn', 'btn-extra-large', 'green-btn', 'align-right', 'move-to-next-screen-btn']} selected={false} text='Go to Magnetboard' onClickFunction={handleGoToMagnetboard} />
				</div>
			</>
		)
		}
		</>
	)
}
